/* ToolbarDropdownItem.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./ToolbarDropdownItem.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React, { forwardRef } from 'react';
import { cx } from '@atlaskit/css';
import { DropdownItem } from '@atlaskit/dropdown-menu';
import { Pressable } from '@atlaskit/primitives/compiled';
var styles = {
  toolbarDropdownItem: "_18zrpxbi _1rjcu2gc _1e0c1txw _kqswh2mm _bfhksm61 _1bsb1osq _1tke14no _1ul9163w _1basglpi _1ah31i6y",
  enabled: "_irr3166n _1di61dty",
  disabled: "_syaz1lh4 _80om13gf",
  selected: "_bfhkfg4m _syazaqb7 _irr3i1yw _1di619ru"
};
var CustomDropdownMenuItemButton = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
    testId = _ref['data-testid'],
    ariaHasPopup = _ref['aria-haspopup'],
    ariaDisabled = _ref['aria-disabled'],
    ariaPressed = _ref['aria-pressed'],
    ariaKeyshortcuts = _ref['aria-keyshortcuts'],
    onClick = _ref.onClick,
    tabIndex = _ref.tabIndex;
  return /*#__PURE__*/React.createElement(Pressable, {
    testId: testId,
    xcss: cx(styles.toolbarDropdownItem, ariaDisabled ? styles.disabled : ariaPressed ? styles.selected : styles.enabled),
    onClick: onClick,
    tabIndex: tabIndex,
    "aria-haspopup": ariaHasPopup,
    "aria-expanded": ariaHasPopup ? ariaPressed ? true : false : undefined,
    "aria-pressed": ariaPressed,
    "aria-disabled": ariaDisabled,
    "aria-keyshortcuts": ariaKeyshortcuts,
    ref: ref
  }, children);
});
export var ToolbarDropdownItem = function ToolbarDropdownItem(_ref2) {
  var onClick = _ref2.onClick,
    elemBefore = _ref2.elemBefore,
    elemAfter = _ref2.elemAfter,
    isSelected = _ref2.isSelected,
    children = _ref2.children,
    isDisabled = _ref2.isDisabled,
    hasNestedDropdownMenu = _ref2.hasNestedDropdownMenu,
    triggerRef = _ref2.triggerRef,
    testId = _ref2.testId,
    ariaKeyshortcuts = _ref2.ariaKeyshortcuts;
  return /*#__PURE__*/React.createElement(DropdownItem, {
    onClick: onClick,
    elemBefore: elemBefore,
    elemAfter: elemAfter,
    isSelected: isSelected,
    isDisabled: isDisabled,
    "aria-haspopup": hasNestedDropdownMenu,
    "aria-pressed": isSelected,
    "aria-keyshortcuts": ariaKeyshortcuts,
    ref: triggerRef,
    component: CustomDropdownMenuItemButton,
    testId: testId
  }, children);
};